"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const user_role_entity_1 = require("./user-role.entity");
const look_up_entity_1 = require("./look-up.entity");
const org_branch_entity_1 = require("./org-branch.entity");
const org_vertical_entity_1 = require("./org-vertical.entity");
const opportunity_activity_participants_entity_1 = require("./opportunity-activity-participants.entity");
const opportunity_entity_1 = require("./opportunity.entity");
const organisation_entity_1 = require("./organisation.entity");
let User = class User {
    constructor(partial) {
        Object.assign(this, partial);
    }
};
exports.User = User;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id" }),
    tslib_1.__metadata("design:type", Number)
], User.prototype, "userId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "salutation_lid" }),
    tslib_1.__metadata("design:type", Number)
], User.prototype, "salutationLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "first_name" }),
    tslib_1.__metadata("design:type", String)
], User.prototype, "firstName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "last_name" }),
    tslib_1.__metadata("design:type", String)
], User.prototype, "lastName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "email_id", unique: true }),
    tslib_1.__metadata("design:type", String)
], User.prototype, "emailId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "mobile", unique: true }),
    tslib_1.__metadata("design:type", String)
], User.prototype, "mobile", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "login_name", unique: true }),
    tslib_1.__metadata("design:type", String)
], User.prototype, "loginName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "password" }),
    tslib_1.__metadata("design:type", String)
], User.prototype, "password", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "branch_id" }),
    tslib_1.__metadata("design:type", Number)
], User.prototype, "branchId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "vertical_id" }),
    tslib_1.__metadata("design:type", Number)
], User.prototype, "verticalId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "department_id" }),
    tslib_1.__metadata("design:type", Number)
], User.prototype, "departmentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "designation_id" }),
    tslib_1.__metadata("design:type", Number)
], User.prototype, "designationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "organisation_id" }),
    tslib_1.__metadata("design:type", Number)
], User.prototype, "organisationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "reporting_user_id" }),
    tslib_1.__metadata("design:type", Number)
], User.prototype, "reportingUserId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "user_type_key" }),
    tslib_1.__metadata("design:type", String)
], User.prototype, "userTypeKey", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], User.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "user_status_key" }),
    tslib_1.__metadata("design:type", String)
], User.prototype, "userStatusKey", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamp",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], User.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamp",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], User.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], User.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], User.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => user_role_entity_1.UserRole, (userRole) => userRole.user),
    tslib_1.__metadata("design:type", Array)
], User.prototype, "userRoles", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamp", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], User.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "salutation_lid" }),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "salutation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => organisation_entity_1.Organisation),
    (0, typeorm_1.JoinColumn)({ name: "organisation_id" }),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "organisation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => org_branch_entity_1.OrgBranch),
    (0, typeorm_1.JoinColumn)({ name: "branch_id" }),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "branch", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => org_vertical_entity_1.OrgVertical),
    (0, typeorm_1.JoinColumn)({ name: "vertical_id" }),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "vertical", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "status_lid" }),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_activity_participants_entity_1.OpportunityActivityParticipants, (participant) => participant.participant),
    tslib_1.__metadata("design:type", Array)
], User.prototype, "participations", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.owner),
    tslib_1.__metadata("design:type", Object)
], User.prototype, "opportunities", void 0);
exports.User = User = tslib_1.__decorate([
    (0, typeorm_1.Entity)("users"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof Partial !== "undefined" && Partial) === "function" ? _a : Object])
], User);
